<template>
  <div>
    <core-modal-header>Session Expired</core-modal-header>

    <core-modal-body>
      <p>Your session expired for security reasons. Sign in again to continue where you left off.</p>
    </core-modal-body>

    <core-modal-footer>
      <u-button @click="$emit('confirm')">Sign In</u-button>
    </core-modal-footer>
  </div>
</template>

<script setup>
defineEmits(['confirm']);
</script>
